import { useState } from 'react';
import useResize from './useResize';
import ViewMoreModal from '../components/ViewMoreModal';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

function useViewMoreModal(contentType = '') {
	const [isSidebarOpen, setIsSidebarOpen] = useState(false);
	const deviceType = useResize();

	// Parent tells us whether to show (based on overflow)
	const ViewMoreButton = ({ shouldShow = false }) => {
		if (!isSidebarOpen && deviceType !== 'mobile' && shouldShow) {
			return (
				<button className="load-more-btn" onClick={() => setIsSidebarOpen(true)}>
					View All
					<ArrowForwardIcon size={20} />
				</button>
			);
		}
		return null;
	};

	const Modal = ({ products, videos, selectedVideo }) => {
		return (
			<>
				{deviceType !== 'mobile' && isSidebarOpen && products && (
					<ViewMoreModal products={products} setIsSideBarOpen={setIsSidebarOpen} contentType={contentType} />
				)}

				{deviceType !== 'mobile' && isSidebarOpen && videos && (
					<ViewMoreModal videos={videos} setIsSideBarOpen={setIsSidebarOpen} selectedVideo={selectedVideo} />
				)}
			</>
		);
	};

	return { ViewMoreButton, Modal };
}

export default useViewMoreModal;
